var map = {
	"./big-volume-harvesting-solution.png": 41,
	"./bioprocess-solution.png": 42,
	"./buffer-and-reagent-solutions.png": 43,
	"./calibration-service.png": 44,
	"./cell-culture-screening-solution.png": 45,
	"./cell-culture-versatility-solution.png": 46,
	"./classic-cell-culture-solution.png": 47,
	"./high-capacity-solution.png": 48,
	"./high-speed-solution.png": 49,
	"./high-throughput-screening-solution.png": 50,
	"./low-throughput-plate-solution.png": 51,
	"./microbiology-screening-solution.png": 52,
	"./microorganism-&-cell-transfer-solutions.png": 53,
	"./mid-size-solution.png": 54,
	"./molecular-biology-benchtop-solution.png": 55,
	"./molecular-biology-solution-2.png": 56,
	"./molecular-biology-solution.png": 57,
	"./preventive-maintenance.png": 58,
	"./qualification-service.png": 59,
	"./screening-solutions.png": 60,
	"./small-scale-solution.png": 61,
	"./versatility-solution.png": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90;